/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PoliJobsCvAccessReportDTO
 */
export interface PoliJobsCvAccessReportDTO {
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsCvAccessReportDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsCvAccessReportDTO
	 */
	companyName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof PoliJobsCvAccessReportDTO
	 */
	companyCui?: string | null;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCvAccessReportDTO
	 */
	cvSharesCount?: number;
	/**
	 *
	 * @type {number}
	 * @memberof PoliJobsCvAccessReportDTO
	 */
	cvDownloadsCount?: number;
}

export function PoliJobsCvAccessReportDTOFromJSON(
	json: any
): PoliJobsCvAccessReportDTO {
	return PoliJobsCvAccessReportDTOFromJSONTyped(json, false);
}

export function PoliJobsCvAccessReportDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): PoliJobsCvAccessReportDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		companyName: !exists(json, "companyName") ? undefined : json["companyName"],
		companyCui: !exists(json, "companyCui") ? undefined : json["companyCui"],
		cvSharesCount: !exists(json, "cvSharesCount")
			? undefined
			: json["cvSharesCount"],
		cvDownloadsCount: !exists(json, "cvDownloadsCount")
			? undefined
			: json["cvDownloadsCount"],
	};
}

export function PoliJobsCvAccessReportDTOToJSON(
	value?: PoliJobsCvAccessReportDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		companyName: value.companyName,
		companyCui: value.companyCui,
		cvSharesCount: value.cvSharesCount,
		cvDownloadsCount: value.cvDownloadsCount,
	};
}
